document.addEventListener('alpine:init', () => {
    Alpine.data('favoritable', ({ id, siteId, loggedIn, gtmData, wire = null }) => ({
        id: id,
        siteId: siteId,
        loggedIn: loggedIn,
        active: false,
        gtmData: gtmData,

        init() {
            if (this.read().includes(this.id)) {
                this.active = true;
            }

            window.addEventListener('my-favorites-updated', (e) => {
                const d = e.detail || {};
                if (d.id === this.id) this.active = !!d.active;
            });
        },

        toggle() {
            const set = new Set(this.read());
            const willBeActive = !set.has(this.id);

            if (willBeActive) set.add(this.id); else set.delete(this.id);
            this.write(Array.from(set));
            this.active = willBeActive;

            window.dispatchEvent(new CustomEvent('my-favorites-updated', {
                detail: { id: this.id, active: this.active }
            }));

            this.pushGtmEvent(this.active ? 'add_to_wishlist' : 'remove_from_wishlist');

            if (this.loggedIn) {
                if (wire) {
                    wire.syncFavorite(this.active).catch(this.revertState.bind(this));
                }
                else {
                    if (window.Livewire) {
                        window.Livewire.dispatch('sync-global-favorite', { id: this.id, active: this.active });
                    }
                }
            }
        },

        revertState() {
             const r = new Set(this.read());
             if (this.active) r.delete(this.id); else r.add(this.id);
             this.write(Array.from(r));
             this.active = !this.active;
             window.dispatchEvent(new CustomEvent('my-favorites-updated', { detail: { id: this.id, active: this.active } }));
        },

        read() {
            var name = 'my-favorites-' + this.siteId + '=';
            var all = document.cookie ? document.cookie.split('; ') : [];
            var value = null;

            for (var i = 0; i < all.length; i++) {
                if (all[i].indexOf(name) === 0) {
                    value = all[i].slice(name.length);
                }
            }

            if (value === null) return [];
            try {
                var data = JSON.parse(decodeURIComponent(value));
                return Array.isArray(data) ? data : [];
            } catch (e) {
                return [];
            }
        },

        write(arr) {
            var value = encodeURIComponent(JSON.stringify(arr));
            var maxAge = 60 * 60 * 24 * 120;
            var parts = [
                'my-favorites-' + this.siteId + '=' + value,
                'Path=/',
                'Max-Age=' + maxAge,
                'SameSite=Lax'
            ];

            var h = location.hostname;
            var isIP = /^\d{1,3}(\.\d{1,3}){3}$/.test(h);
            if (h.indexOf('.') !== -1 && !isIP) {
                parts.push('Domain=.' + h);
            }
            if (location.protocol === 'https:') {
                parts.push('Secure');
            }

            document.cookie = parts.join('; ');
        },

        pushGtmEvent(eventName = 'add_to_wishlist') {
            if (this.gtmData && Object.keys(this.gtmData).length > 0) {
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    event: eventName,
                    ...this.gtmData
                });
            }
        }
    }));
});
